import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PrivacyPolicyService {
    private apiUrl = `${environment.apiUrl}/zivo/politicas`;

    constructor(private http: HttpClient) { }

    list(params?: any): Observable<any> {
        let httpParams = new HttpParams();

        if (params) {
            Object.keys(params).forEach((key) => {
                if (params[key] !== null && params[key] !== undefined) {
                    httpParams = httpParams.set(key, params[key]);
                }
            });
        }

        return this.http.get(`${this.apiUrl}/`, { params: httpParams });
    }
    create(data: any) {
        return this.http.post(`${this.apiUrl}/`, data);
    }
    view(id: string): Observable<Blob> {
        return this.http.get(`${this.apiUrl}/${id}/view`, {
            responseType: 'blob',
        });
    }
    viewCurrent(target: 'employee' | 'prospect', policy_type?: string): Observable<Blob> {
        let params = new HttpParams();

        if (target === 'employee') {
            params = params.set('employee', 'true');
        }

        if (target === 'prospect') {
            params = params.set('prospect', 'true');
        }
        if (policy_type) {
            params = params.set('policy_type', policy_type)
        }
        return this.http.get(`${this.apiUrl}/view`, {
            params,
            responseType: 'blob',
        });
    }

    viewEmployeePrivacyPolicy(policyId: string) {
        return this.http.get(`${this.apiUrl}/${policyId}/view`, {
            responseType: 'blob',
        });
    }

    acceptPolicyFromLogin(policyId: string) {
        const token = localStorage.getItem('token');

        const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
        });

        return this.http.post(
            `${this.apiUrl}/consentimientos/me/accept`,
            {
                privacy_policy_id: policyId,
                source: 'LOGIN',
            },
            { headers },
        );
    }
    listConsentimientos(params?: any): Observable<any> {
        let httpParams = new HttpParams();

        if (params) {
            Object.keys(params).forEach((key) => {
                if (params[key] !== null && params[key] !== undefined) {
                    httpParams = httpParams.set(key, params[key]);
                }
            });
        }

        return this.http.get(`${this.apiUrl}/consentimientos`, { params: httpParams });
    }
}
